import {
  getIconForFile,
  getIconForFolder,
  getIconForOpenFolder,
} from 'vscode-icons-js';

/** Iconify collection prefix for the vscode-icons set. */
export const ICON_PREFIX = 'vscode-icons';

/**
 * Convert a vscode-icons asset filename (e.g. `file_type_js.svg`) into an
 * Iconify icon name (e.g. `vscode-icons:file-type-js`). When the resolver
 * returns nothing, fall back to `fallbackAsset` so callers always get a real,
 * registered default icon.
 */
function toIconifyName(asset: string | undefined, fallbackAsset: string): string {
  const file = asset && asset.length > 0 ? asset : fallbackAsset;
  const key = file.replace(/\.svg$/, '').replace(/_/g, '-');
  return `${ICON_PREFIX}:${key}`;
}

/** Iconify icon name for a file, by its basename. */
export function iconNameForFile(name: string): string {
  return toIconifyName(getIconForFile(name), 'default_file.svg');
}

/** Iconify icon name for a folder, by its basename and open/closed state. */
export function iconNameForFolder(name: string, open: boolean): string {
  const asset = open ? getIconForOpenFolder(name) : getIconForFolder(name);
  return toIconifyName(asset, open ? 'default_folder_opened.svg' : 'default_folder.svg');
}
